import { generateGuid, capFirstLetter } from 'src/Utils';
import { formatDate } from '../../Utils';

export default function DocumentTable({ documents, title, showPdfText, id, profile }) {

    const displayRow = () => {
        const rows =
            documents.map((document, i) => (
                <tr key={generateGuid()}>
                    <td data-testid={`${id}DocumentTypeValue${i}`} className="text-align-left">{capFirstLetter(document.type)}</td>
                    <td data-testid={`${id}LanguageValue${i}`} className="text-align-left">English</td>
                    <td data-testid={`${id}EffectiveDateValue${i}`} className="text-align-left"> {document.effectiveDate ? formatDate(document.effectiveDate) : '-'}</td>
                    <td data-testid={`${id}FormatValue${i}`} className="text-align-left"><a href={document.url} target="_blank" rel="noreferrer" className="text-underline-none font-weight-bold"><i className="far fa-file-pdf"></i>{showPdfText ? ' View pdf' : null}</a></td>
                </tr>
            ));

        return rows;
    }

    return <div className="ajb-grid-row margin-top-20">
        <div className="ajb-grid-row">
            <div className="ajb-col-12 ajb-col-8-breakpoint margin-top-30-sm">
                <div className="card z-depth-0 margin-0">
                    <div className="card-content padding-top-0 padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
                        <div className="ajb-grid-row">
                            <h2 className="card-title" data-testid={`${id}Header`}>{title}</h2>
                        </div>
                        <div className="ajb-grid-row">
                            <table className="data-table data-table--small data-table--scroll highlight margin-top-0 margin-bottom-10">
                                <thead>
                                    <tr>
                                        <th data-testid={`${id}DocumentTypeTableHead`} className="text-align-left">Document type</th>
                                        <th data-testid={`${id}LanguageTableHead`} className="text-align-left">Language</th>
                                        <th data-testid={`${id}EffectiveDateTableHead`} className="text-align-left">Effective date</th>
                                        <th data-testid={`${id}FormatTableHead`} className="text-align-left">Format</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayRow()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}